import { render, staticRenderFns } from "./OnboardingUnfinishedTable.vue?vue&type=template&id=95e1fbaa&"
import script from "./OnboardingUnfinishedTable.vue?vue&type=script&lang=js&"
export * from "./OnboardingUnfinishedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports